<template>
    <div>

        <b-modal
                no-close-on-backdrop
                hide-footer
                ref="tripEditModal"
                size="lg"
                body-class="bg-white"
                v-on:close="onComplete"
                v-on:cancel="onComplete"
                v-on:hide="onComplete"
                @cancel="onComplete"
                @close="onComplete"
                :title="trip_short_desc">

            <div style="padding:0px;width: 100%; height:100%">
                <form-wizard
                        ref="formWizRef"
                        @on-complete="onWizzardComplete"
                        @on-loading="setLoading"
                        @on-validate="handleValidation"
                        @on-error="handleErrorMessage"
                        shape="circle"
                        color="#e67e22"

                        error-color="#e74c3c"
                        title="Add/Edit Trip"
                        subtitle=""
                >


                    <tab-content title="Basic informations"
                                 icon="ti-user"
                                 :before-change="validateBasicInfo"
                    >
                        <div class="md-layout">
                            <b-form-group
                                    horizontal
                                    label="Name of the trip"
                                    label-for="search-select"
                                    :label-cols="3"
                            >
                                <b-input
                                        class="inputx"
                                        placeholder="My trip to ..."
                                        v-model="trip_short_desc"/>
                            </b-form-group>


                            <b-form-group
                                    horizontal
                                    label="Type of trip"
                                    :label-cols="3"
                            >

                                <v-select
                                        v-model="trip_type"
                                        :options="Object.keys(this.trip_type_options).sort()"
                                />

                            </b-form-group>
                        </div>
                    </tab-content>

                    <tab-content title="Track and maps"
                                 icon="ti-map"
                                 :before-change="validateMapInfo"
                    >
                        Use the map to enter the trip from start to finish. When done Press "Next"


                        <div id="mapEditTrip" style="padding:0px;width: 100%; height:400px"></div>


                    </tab-content>


                    <tab-content title="Upload Photos"
                                 icon="ti-image">

                        <div v-if="selectedTrip">
                            <add-edit-trip-photos
                            :selectedTrip="selectedTrip"
                            ></add-edit-trip-photos>
                        </div>
                    </tab-content>


                    <tab-content title="Geo-Localisation"
                                 icon="ti-map-alt">

                        <add-edit-trip-photos-localisation
                                :selected-trip="selectedTrip"
                        >

                        </add-edit-trip-photos-localisation>

                    </tab-content>


                    <div class="loader" v-if="loadingWizard"></div>
                    <div v-if="errorMsg">
                        <span class="error">{{errorMsg}}</span>
                    </div>
                </form-wizard>


            </div>

        </b-modal>


        <!--        <b-modal-->
        <!--                hide-footer-->
        <!--                ref="tripEditImagePosition"-->
        <!--                id="tripEditImagePosition"-->
        <!--                size=""-->
        <!--                body-class="bg-white"-->
        <!--                v-on:close=""-->
        <!--                v-on:cancel=""-->
        <!--                title="Edit position">-->
        <!--test asdf-->
        <!--        </b-modal>-->


    </div>

</template>


<script>

  import AddEditTripPhotosLocalisation from '@/pages/AddEditTripPhotosLocalisation'
  import PhotosLocalisation from '@/components/PhotosLocalisation/PhotosLocalisation'

  const fb = require('../firebaseConfig.js')
  import { mapState } from 'vuex'

  import gmapsInit from '../googleMapsConfig'

  import AddEditTripPhotos from './AddEditTripPhotos'
  //////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////
  import { FormWizard, TabContent } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import LightBox from 'vue-image-lightbox'
  //////////////////////////////////////////////////////////////////////////
  import UIHelpersMixins from '../mixims/UIHelpersMixins'


  //////////////////////////////////////////////////////////////////////////
  import Vue from 'vue'
  //////////////////////////////////////////////////////////////////////////

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  //////////////////////////////////////////////////////////////////////////
  import vSelect from 'vue-select'

  const TRIP_TYPES = require('@/components/Trips/TripTypes.js')
  //////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////

  export default {
    mixins:
                [
                  UIHelpersMixins,
                ],
    components: {
      LightBox,
      vSelect,
      FormWizard,
      TabContent,
      AddEditTripPhotos,
      AddEditTripPhotosLocalisation,
      PhotosLocalisation,
    },
    data ()
    {
      return {
        startIndex: 0,

        trip_short_desc: '',
        trip_type:       '',

        trip_poly: null,

        trip_routeSegments: [],
        trip_uid:           null,

        loadingWizard: false,
        errorMsg:      null,

        // Value must be one of the following for Google Direction Service API
        // [[ blank ]]j
        // DRIVING
        // WALKING
        // BICYCLING
        // TRANSIT
        trip_type_options: TRIP_TYPES.types,
      }
    },

    beforeCreate: function () {

    },
    mounted ()
    {
      var that = this
      this.clearTrip()

    },
    computed:     {
      currentUser ()
      {
        return this.$store.getters.currentUser
      },
      selectedTrip ()
      {
        return this.$store.getters.selectedTrip
      },

      isAuthenticated ()
      {
        return this.currentUser !== null || this.currentUser !== undefined
      },
      error ()
      {
        return this.$store.state.error
      },
      loading ()
      {
        return this.$store.state.loading
      },

    }, // computed

    methods: {

      initMap ()
      {
        // Regular Map
        const mapOptions = {
          zoom:                   12,
          center:                 new google.maps.LatLng(45.7, -73.90),
          mapTypeId:              google.maps.MapTypeId.TERRAIN,
          zoomControl:            false,
          mapTypeControl:         true,
          scaleControl:           false,
          panControl:             false,
          fullscreenControl:      true,
          navigationControl:      false,
          disableDoubleClickZoom: true,
          streetViewControl:      false,
          mapTypeControlOptions:  {
            style:      google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID,
              google.maps.MapTypeId.SATELLITE, google.maps.MapTypeId.TERRAIN]
          },
          scrollwheel:            true,
          draggableCursor:        'crosshair',
          animation:              google.maps.Animation.BOUNCE,
          gestureHandling:        'greedy',
          styles:                 [{
            'featureType': 'poi.attraction',
            'stylers':     [{
              'visibility': 'off'
            }]
          },
            {
              'featureType': 'poi.business',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.medical',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.place_of_worship',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'poi.school',
              'stylers':     [{
                'visibility': 'off'
              }]
            },
            {
              'featureType': 'transit.station.bus',
              'stylers':     [{
                'visibility': 'off'
              }]

            }
          ]
        }

        console.log(document.getElementById('mapEditTrip'))
        this.map = new google.maps.Map(document.getElementById('mapEditTrip'), mapOptions)
      },

      handleLoadTrip: function () {
        var that = this

        if (this.selectedTrip)
        {
          var selectedTripId = that.selectedTrip.id
          console.log('Editing ', selectedTripId)
          fb.tripsCollection.doc(selectedTripId).onSnapshot(doc => {

            if (!doc.exists)
            {
              return
            }

            var data = doc.data()

            that.handleBeginEdit(that.map, that.sanitizeDB(data))

            // if (that.trip_routeSegments.length >= 1)
            // {
            //
            //   fb.mediasCollection.where('tripId', '==', selectedTripId).orderBy('capturedOn', 'asc')
            //     .onSnapshot(function (querySnapshot) {
            //
            //       if (querySnapshot.docs.length)
            //       {
            //       }
            //     })
            //
            // }

          })
        } else
        {
          console.log('Adding new trip')
          that.handleBeginEdit(that.map, that.sanitizeDB())
        }

      },

      setTab: function (i) {
        if (this.$refs.formWizRef)
        {
          this.$refs.formWizRef.changeTab(0, i)
        }
      },
      openTab ()
      {
        var goToTab = 0
        if (this.selectedTrip)
        {
          goToTab = 1

          if (this.selectedTrip.route_lengthMeters >= 1)
          {
            //    goToTab = 2

            // if (querySnapshot.docs.length)
            // {
            //   goToTab = 3
            // }
          }
        }
        this.setTab(goToTab)
      },
      show ()
      {
        var that = this
        this.openTab()
        this.$refs.tripEditModal.show()

        gmapsInit().then(function () {

          Vue.nextTick(function () {

            that.initMap()
            google.maps.event.addListenerOnce(that.map, 'idle', function () {

              console.log('that.handleLoadTrip()')
              that.handleLoadTrip()

              that.openTab()

            })
          })
        })

      },

      onWizzardComplete ()
      {
        this.$refs.tripEditModal.hide()
        this.$emit('close')
      },
      onComplete:         function () {

        //this.$refs.tripEditModal.hide()

        this.$emit('close')
      },
      setLoading:         function (value) {
        this.loadingWizard = value
      },
      handleValidation:   function (isValid, tabIndex) {
        console.log('Tab: ' + tabIndex + ' valid: ' + isValid)
      },
      handleErrorMessage: function (errorMsg) {
        this.errorMsg = errorMsg
      },

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      validateBasicInfo: function () {
        var that = this
        return new Promise((resolve, reject) => {

          if (that.trip_short_desc.length < 4)
          {
            reject('You must add a name')
            return
          }
          if (!that.trip_type.length)
          {
            reject('You must select a trip type')
            return
          }

          if (that.selectedTrip)
          {

            fb.tripsCollection.doc(that.selectedTrip.id).update({
              updatedOn:  new Date(),
              short_desc: that.trip_short_desc,
              type:       that.trip_type,
            }).then(() => {
              that.notifyVue('success', that.trip_short_desc + ' Saved!')

              resolve(true)
            })
          } else
          {
            // Not saving anything yet
            resolve(true)
          }

        })
      },
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////     MAP METHODS                                                                       /////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      validateMapInfo: function () {
        var that = this
        return new Promise((resolve, reject) => {

          if (that.trip_poly.getPath().length < 2)
          {
            reject('You must add at least 2 points on the map')
            return
          }
          var routeSegments = []
          var routeLength   = 0
          that.trip_routeSegments.forEach(function (k, v) {
            routeSegments.push(google.maps.geometry.encoding.encodePath(k.getPath()))
            routeLength += google.maps.geometry.spherical.computeLength(k.getPath())
          })

          if (that.selectedTrip)
          {
            var selectedTripId = that.selectedTrip.id

            fb.tripsCollection.doc(selectedTripId).update({
              updatedOn:          new Date(),
              poly:               google.maps.geometry.encoding.encodePath(that.trip_poly.getPath()),
              route_segments:     routeSegments,
              route_lengthMeters: routeLength,
            }).then(() => {
              that.notifyVue('success', that.trip_short_desc + ' Saved!')

              resolve(true)
            })
          } else
          {
            fb.tripsCollection.add({
              createdOn:          new Date(),
              updatedOn:          new Date(),
              short_desc:         that.trip_short_desc,
              type:               that.trip_type,
              uid:                that.currentUser.uid,
              poly:               google.maps.geometry.encoding.encodePath(that.trip_poly.getPath()),
              route_segments:     routeSegments,
              route_lengthMeters: routeLength,

            }).then(ref => {

              fb.tripsCollection.doc(ref.id).get().then(function (doc) {

                that.$store.commit('setSelectedTrip', doc)
                //   that.$router.push('/explore//trips/' + ref.id + '/edit')
              })

              fb.activityCollection.add({
                createdOn: new Date(),
                updatedOn: new Date(),
                uid:       this.currentUser.uid,

                action:   'trip_added',
                contents: {
                  commentId: ref.id,
                },
                source:   {
                  url:        '/explore//trips/' + ref.id,
                  id:         ref.id,
                  collection: 'trips',
                }
              })

              that.notifyVue('success', that.trip_short_desc + ' Added!')
              resolve(true)

            }).catch(err => {

              console.log(err)
              reject(err)

            })

          }

        })
      },

      clearTrip:       function () {

        if (this.trip_poly)
        {
          this.trip_poly.setMap(null)
          this.trip_poly = null
        }

        this.trip_routeSegments.forEach(function (k, v) {
          k.setMap(null)
        })
        this.trip_routeSegments = []

      },
      loadTrip:        function (map, data) {
        this.clearTrip()

        var that   = this
        var bounds = new google.maps.LatLngBounds()

        this.trip_short_desc = data.short_desc || ''
        this.trip_type       = data.type || ''

        //   if (data.poly === undefined || data.poly.length === 0)
        //     return

        this.trip_poly = new google.maps.Polyline({
          clickable: false,
          map:       map,
          path:      google.maps.geometry.encoding.decodePath(data.poly)
        })
        this.trip_poly.getPath().forEach(function (k, v) {
          bounds.extend(k)
        })
        that.trip_routeSegments = []

        // if (!data.route_segments || data.route_segments.length === 0)  //rebuild segments from polyline if needed
        // {
        //   var prevSeg = null
        //   data.route_segments = []
        //
        //   this.trip_poly.getPath().forEach(function (k, v) {
        //
        //     if (prevSeg)
        //     {
        //       var segment_poly = new google.maps.Polyline({
        //         path: [
        //           {lat: prevSeg.lat(), lng: prevSeg.lng()},
        //           {lat: k.lat(), lng: k.lng()},
        //         ],
        //       })
        //
        //       data.route_segments.push( google.maps.geometry.encoding.encodePath(segment_poly.getPath()))
        //     }
        //     prevSeg = k
        //   })
        // }

        data.route_segments.forEach(function (k, v) {

          var gpSegment_poly = new google.maps.Polyline({
            clickable:    true,
            strokeColor:  that.getColor(v),
            strokeWeight: 4,
            path:         google.maps.geometry.encoding.decodePath(k),
          })
          gpSegment_poly.setMap(map)

          that.trip_routeSegments[v] = gpSegment_poly
        })
        map.fitBounds(bounds)

      },
      handleBeginEdit: function (map, data) {
        this.loadTrip(map, data)

        var that = this

        this.trip_poly.setEditable(true)

        google.maps.event.addListener(map, 'click', function (event) {
          console.log('Map PanTO')

          var path = that.trip_poly.getPath()
          path.push(event.latLng)

          that.map.panTo(event.latLng)
        })

        google.maps.event.addListener(that.trip_poly.getPath(), 'dragend', function () {

          that.polyChanged_DragEnd(map)

        })

        google.maps.event.addListener(that.trip_poly, 'click', function (index) {

          that.polyChanged_RemoveVertexAt(map, index)

        })
        google.maps.event.addListener(that.trip_poly.getPath(), 'insert_at', function (index) {

          that.polyChanged_InsertAt(map, index)

        })
        google.maps.event.addListener(that.trip_poly.getPath(), 'remove_at', function (index, removed) {

          that.polyChanged_RemoveAt(map, index, removed)

        })
        google.maps.event.addListener(that.trip_poly.getPath(), 'set_at', function (index, previous) {

          that.polyChanged_SetAt(map, index, previous)

        })

        if (this.trip_routeSegments.length === 0)
        {
          for (let i = 0; i < that.trip_poly.getPath().length; i += 2)
          {
            setTimeout(function () {
              that.polyChanged_SetAt(map, i, that.trip_poly.getPath().getAt(i))
            }, 1000 * i)
          }

        }
      },
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      sanitizeDB:      function (trip) {

        trip            = trip || {}
        trip.id         = trip.id || null
        trip.uid        = trip.uid || ''
        trip.short_desc = trip.short_desc || ''
        trip.type       = trip.type || ''

        trip.poly           = trip.poly || []
        trip.route_segments = trip.route_segments || []

        return trip
      },

      editTripBegin: function (map, polyToEdit) {

      },

      editTripCancel: function () {
        console.log('Map editTripCancel')
        this.isEditMode = false

        this.resetForm()
      },

      polyChanged_DragEnd:  function (map) {
        console.log('Map polyChanged_DragEnd')
      },
      polyChanged_InsertAt: function (map, index) {
        console.log('Insert at ' + index + ' ' + this.trip_poly.getPath().getAt(index).toString())
        var that = this
        if (index === 0)
          return

        // insert in middle
        if (index < this.trip_poly.getPath().length - 1)
        {
          if (this.trip_routeSegments[index - 1])
          {
            this.trip_routeSegments[index - 1].setMap(null)
          }

          this.trip_routeSegments.splice(index, 0, null)

          this.fetchRoute(
            this.trip_poly.getPath().getAt(index - 1),
            this.trip_poly.getPath().getAt(index),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)
            that.trip_routeSegments[index - 1] = polyRoute

          })

          this.fetchRoute(
            this.trip_poly.getPath().getAt(index),
            this.trip_poly.getPath().getAt(index + 1),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)
            that.trip_routeSegments[index] = polyRoute

          })

        } else  // insert at end
        {
          this.fetchRoute(
            this.trip_poly.getPath().getAt(index - 1),
            this.trip_poly.getPath().getAt(index),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)

            that.trip_routeSegments[index - 1] = polyRoute
          })
        }

      },

      polyChanged_RemoveAt: function (map, index, removed) {
        console.log('Map polyChanged_RemoveAt')
      },

      polyChanged_RemoveVertexAt: function (map, index) {
        console.log('Map polyChanged_RemoveVertexAt')
        var that   = this
        var vertex = index.vertex
        if (vertex === undefined)
        {
          return
        }

        if (this.trip_routeSegments.length === 0)
        {
          this.trip_poly.getPath().removeAt(vertex)

        } else if (vertex === this.trip_routeSegments.length) // last
        {
          this.trip_routeSegments[vertex - 1].setMap(null)
          this.trip_routeSegments.splice(vertex - 1, 1)
          this.trip_poly.getPath().removeAt(vertex)
        } else if (vertex !== 0)
        {
          this.trip_routeSegments[vertex - 1].setMap(null)
          this.trip_routeSegments[vertex].setMap(null)
          this.trip_routeSegments.splice(vertex - 1, 1)

          this.trip_poly.getPath().removeAt(vertex)

          this.fetchRoute(
            this.trip_poly.getPath().getAt(vertex - 1),
            this.trip_poly.getPath().getAt(vertex),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)
            that.trip_routeSegments[vertex - 1] = polyRoute
          })
        } else
        {
          this.trip_routeSegments[vertex].setMap(null)
          this.trip_routeSegments.splice(vertex, 1)
          this.trip_poly.getPath().removeAt(vertex)
        }
      },
      polyChanged_SetAt:          function (map, index, previous) {

        var that = this
        console.log(index + ' moved from ' + previous.toString() + ' to ' + this.trip_poly.getPath().getAt(index).toString())

        if (index !== 0)
        {
          if (this.trip_routeSegments[index - 1])
          {
            this.trip_routeSegments[index - 1].setMap(null)
          }

          this.fetchRoute(
            this.trip_poly.getPath().getAt(index - 1),
            this.trip_poly.getPath().getAt(index),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)

            that.trip_routeSegments[index - 1] = polyRoute
          })
        }

        if (index !== this.trip_poly.getPath().length - 1)
        {
          if (this.trip_routeSegments[index])
          {
            this.trip_routeSegments[index].setMap(null)
          }

          this.fetchRoute(
            this.trip_poly.getPath().getAt(index),
            this.trip_poly.getPath().getAt(index + 1),
            this.trip_type
          ).then(function (polyRoute) {
            polyRoute.setMap(map)

            that.trip_routeSegments[index] = polyRoute
          })

        }

      }
      ,
      getPath:                    function () {
        var path     = this.trip_poly.getPath()
        var len      = path.getLength()
        var coordStr = ''
        for (var i = 0; i < len; i++)
        {
          coordStr += path.getAt(i).toUrlValue(6) + '<br>'
        }
        document.getElementById('poly_path').innerHTML = coordStr
      },
      fetchRoute:                 function (origin, destination, trip_type) {
        var that       = this
        var travelMode = this.trip_type_options[trip_type] || ''

        var routePoly = new google.maps.Polyline({
          clickable:   true,
          strokeColor: this.getColor(this.trip_poly.getPath().length),
        })

        return new Promise(function (resolve, reject) {

          if (travelMode === '')
          {
            routePoly.getPath().push(origin)
            routePoly.getPath().push(destination)
            return routePoly
          }

          var directionService = new google.maps.DirectionsService() /// @todo
          directionService.route({
            origin:      origin,
            destination: destination,
            travelMode:  travelMode,
            avoidTolls:  true
          }, function (response, status) {
            if (status === 'OK')
            {
              for (var i = 0, len = response.routes[0].overview_path.length;
                   i < len; i++)
              {
                routePoly.getPath().push(response.routes[0].overview_path[i])
              }

              resolve(routePoly)

            } else if (travelMode === 'BICYCLING' && status === 'ZERO_RESULTS')
            {
              that.fetchRoute(origin, destination, 'Driving').then(function (result) {
                resolve(result)
              })

            } else
            {
              routePoly.getPath().push(origin)
              routePoly.getPath().push(destination)
              resolve(routePoly)
            }
          })

        })
      },
      getColor:                   function (i) {
        var colors = [
          '#6e27d2', '#338cc8', '#714908', '#de0ca0',
          '#e2b265', '#12fb8d', '#d35545', '#99b0e9',
          '#e000e7', '#d28d94', '#a42445', '#e1e45b',
          '#082902', '#1793f6', '#eb26fa', '#8e7d78',
          '#d4120d', '#012f35', '#814226', '#b58cd9',
          '#4d791f', '#4a5103', '#dbf167', '#70f16a',
          '#7e58d8', '#431d8f', '#f1cc7c', '#6578ad',
          '#2d7a74', '#ec35fa', '#01b689', '#47f387',
          '#038718', '#e739ea', '#c8c81b', '#ebecba',
          '#73c99b', '#7c6eac', '#629464', '#e25114']

        return colors[i % colors.length]
      },

    }, // methods

    watch: {
      '$route' (to, from)
      {
        console.log('WATCH: $route')

      },
      selectedTrip (value)
      {
        console.log('WATCH: TripEdit->SelectedTrip')

     //   this.handleLoadTrip()

      },
    }
  }
</script>


<style>

    .vue-form-wizard .wizard-nav li {
        background-color: #fff !important;
    }

    .vue-form-wizard .wizard-tab-container {
        background-color: #fff !important;
    }

    .vue-form-wizard .wizard-nav li.active {
        background-color: #eafff4 !important;
    }

    .vue-form-wizard .wizard-nav li.active span {
        color: #000 !important;
    }

    span.error {
        /*color: #e74c3c;*/
        font-size: 20px;
        display: flex;
        justify-content: center;
    }
</style>